<template>
  <top-content>
    <list-inline v-if="state.contentTypeId === 1" :list="state.list" toPath="/rlzy/xq/" />
    <list-time-inline-block v-if="state.contentTypeId !== 1" :list="state.list" toPath="/rlzy/xq/"/>
    <pagination :total="state.total"  @changePage="handleRefresh" />
<!--    <div v-if="state.list.length === 0">暂无数据</div>-->
  </top-content>
</template>

<script setup>
import TopContent from "./topContent.vue";
import {getRLZYList} from "../../../apis/rlzy";
const Route = useRoute();

const state = reactive({
  list: [],
  pageSize: 10,
  page: 1,
  total: 0,
  contentTypeId: null
})
// 定义路由与类型对照表
let router_typeId = {
  "/rlzy/jypx": 1,
  "/rlzy/xxgk": 2,
  "/rlzy/rczp": 3,
}
// 根据路由获取类型id
state.contentTypeId = router_typeId[Route.path]

const list = ref({})
const listRes = await useAsyncData('getRLZYListByJYPX', () => getRLZYList({contentTypeId: state.contentTypeId, page:state.page, pageSize:state.pageSize}))
if (listRes.data.value.code !== 200) {
  state.list = []
  throw createError({statusCode: listRes.data.value.code, statusMessage: encodeURIComponent("获取人力资源列表失败")})
} else {
  state.list = listRes.data.value.data.list
  state.total = listRes.data.value.data.total
}

function handleRefresh(value) {
  state.page = value
  listRes.refresh()
}

watch(listRes.data, (value => {
  if (value.code !== 200) {
    throw createError({statusCode: value.code, statusMessage: encodeURIComponent("获取人力资源列表失败")})
  } else {
    state.total = value.data.total
    state.list = value.data.list
  }
}))
</script>

<style scoped>

</style>